export const ApiConfig = {
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer xfdjkmnfb m,',
    }
};

// export const addAuthHeader = (token) => ({
//     'Authorization': `Bearer ${token}`
// });

